import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { VerticeSidebarLogo } from '../VerticeLogo';
import Drawer from '@mui/material/Drawer';
import { Box, Button, List, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import CloudIcon from '@mui/icons-material/Cloud';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from "../../contexts/AuthContext";
import { WHITE } from '@Components/VerticeLogo';
import generatePDF, { Resolution } from 'react-to-pdf';
const adminOptions = [{ icon: _jsx(AddIcon, {}), text: 'New Study', route: '/new-study' }, {
        icon: _jsx(CloudIcon, {}),
        text: 'Studies',
        route: '/studies'
    }];
const NavDrawer = ({ maxWidth, logoColor }) => {
    const { studyUuid } = useParams();
    const { logout, userData, isAuthenticated } = useAuth();
    const location = useLocation();
    const topRightBorderRadius = '32px';
    const navigate = useNavigate();
    const handleGeneratePDF = () => {
        const element = document.querySelector('#WellAnalysisPage');
        if (!element || !(element instanceof HTMLElement)) {
            console.error('Element #WellAnalysisPage not found.');
            return;
        }
        const options = {
            method: "save",
            filename: "well-analysis.pdf",
            resolution: Resolution.MEDIUM,
            page: {
                format: "a4",
                orientation: "portrait",
            },
            canvas: {
                mimeType: "image/jpeg",
                qualityRatio: 0.9,
            },
        };
        generatePDF(() => element, options);
    };
    let backgroundColor;
    let textColor;
    if (logoColor == WHITE) {
        backgroundColor = "#CF372C";
        textColor = "#FFFFFF";
    }
    else {
        backgroundColor = "#FFFFFF";
        textColor = "#000000";
    }
    const navigateToRoute = (route) => {
        navigate(route);
    };
    const studyOptions = [{ icon: _jsx(SpaceDashboardIcon, {}), text: "Study Dashboard", route: `/studies/${studyUuid || ''}` }];
    return (_jsxs(Drawer, { variant: "permanent", elevation: 16, open: true, PaperProps: {
            elevation: 16, sx: {
                backgroundColor: backgroundColor, width: `${maxWidth}px`, borderTopRightRadius: topRightBorderRadius,
            }
        }, children: [_jsx(VerticeSidebarLogo, { color: logoColor }), _jsxs(Box, { sx: { display: "flex", flexDirection: "column", height: "100%", justifyContent: "space-between" }, children: [_jsxs(List, { sx: {
                            display: 'flex', flexDirection: 'column', padding: '4px 20px', color: textColor,
                        }, children: [userData && userData.isStaff && _jsxs(_Fragment, { children: [_jsx(ListItemText, { children: "Admin Tools" }), adminOptions.map(({ icon, text, route }) => (_jsxs(ListItemButton, { dense: true, divider: false, selected: location.pathname === route, onClick: () => {
                                            navigateToRoute(route);
                                        }, children: [_jsx(ListItemIcon, { sx: { color: 'inherit' }, children: icon }), _jsx(ListItemText, { primary: text })] }, text)))] }), studyUuid && _jsxs(_Fragment, { children: [_jsx(ListItemText, { children: "Study Tools" }), _jsx(Button, { onClick: async () => {
                                            handleGeneratePDF();
                                        }, variant: "contained", sx: { marginBottom: 2 }, children: "Print PDF" }), studyOptions.map(({ icon, text, route }) => (_jsxs(ListItemButton, { dense: true, divider: false, onClick: () => {
                                            navigateToRoute(route);
                                        }, children: [_jsx(ListItemIcon, { sx: { color: 'inherit' }, children: icon }), _jsx(ListItemText, { primary: text })] }, text)))] })] }), isAuthenticated ? (_jsx(_Fragment, { children: _jsxs(Box, { sx: { display: "flex", color: textColor, flexDirection: "column" }, children: [_jsxs(Typography, { variant: "body1", align: "center", children: ["Logged in as ", userData?.username] }), _jsx(Button, { sx: { color: textColor }, onClick: logout, children: "Logout" })] }) })) : (_jsx(Button, { onClick: () => navigate(`/login?next=${location.pathname}`), sx: { color: textColor }, children: "Login" }))] })] }));
};
export { NavDrawer };
